import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import mainRight from '../../img/main-right.webp';
import notebook from '../../img/notebook.webp';

function Main() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', email: '', text: '', checkbox: false });

  const handleSubmit = () => {
    navigate('/consultation', { state: formData });
  };

  return (
    <>
      {/* Hero Section */}
      <div className="overflow-hidden bg-[#277423] relative pb-[20px] xl:pb-0 xl:h-[770px] max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-0">
        {/* Full bg image - desktop */}

        {/* Right photo overlay - desktop */}
        <img src={mainRight} className="hidden xl:block absolute right-0 top-0 h-full w-[620px] object-cover" alt="" />
        {/* Mobile image */}
        <img src={mainRight} className="xl:hidden block w-full h-[300px] object-cover" alt="" />

        {/* Left text content */}
        <div className="relative z-10 flex flex-col items-start px-[20px] xl:px-[40px] pt-[20px] xl:pt-[155px]">
          <p className="leading-[1.2] text-white text-[36px] xl:text-[64px] font-[600] host-grotesk">{t('home.1')}</p>
          <p className="host-grotesk text-[32px] xl:text-[40px] leading-[1.2] font-[300] text-white max-w-[519px]">{t('home.2')}</p>
          <div className="bg-[#FFFFFF4D] h-px w-full xl:w-[460px] mt-[20px] xl:mt-[140px]"></div>
          <p className="mt-[12px] xl:max-w-[458px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('home.3')}</p>
          <p className="mt-[8px] xl:max-w-[458px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2] font-[700]">{t('home.4')}</p>
        </div>
      </div>

      {/* Form Section */}
      <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row gap-[40px] xl:gap-[60px] pt-[60px] xl:pt-0">
        <img src={notebook} alt="Office" className="hidden xl:block xl:w-[600px] xl:h-[633px] object-cover flex-shrink-0" />
        <img src={notebook} alt="Office" className="xl:hidden block w-full h-[240px] object-cover" />
        <div className="xl:pt-[80px]">
          <p className="host-grotesk leading-[1.2] xl:max-w-[511px] xl:text-[36px] text-[#2A323F] text-[24px]">{t('home.9')}</p>
          <p className="mt-[12px] xl:mt-[20px] xl:max-w-[497px] PtRoot text-[#000000B2] text-[12px] xl:text-[14px]">{t('home.10')}</p>
          <form className="mt-[24px] flex flex-col items-start gap-[12px] xl:gap-[0px] xl:max-w-[437px]">
            <input
              type="text"
              placeholder={t('home.42')}
              className="PtRoot w-full border border-[#0000001A] bg-transparent rounded-md px-[20px] py-[13px] text-[14px] focus:outline-none focus:border-[#2A323F] placeholder-[#00000080]"
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <input
              type="text"
              placeholder={t('home.11')}
              className="PtRoot w-full border border-[#0000001A] bg-transparent rounded-md px-[20px] py-[13px] text-[14px] focus:outline-none focus:border-[#2A323F] placeholder-[#00000080] mt-[12px]"
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            />
            <input
              type="email"
              placeholder={t('home.43')}
              className="PtRoot w-full border border-[#0000001A] bg-transparent rounded-md px-[20px] py-[13px] text-[14px] focus:outline-none focus:border-[#2A323F] placeholder-[#00000080] mt-[12px]"
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
            <textarea
              placeholder={t('home.44')}
              rows={3}
              className="PtRoot w-full border border-[#0000001A] bg-transparent rounded-md px-[20px] py-[13px] text-[14px] focus:outline-none focus:border-[#2A323F] placeholder-[#00000080] resize-none mt-[12px]"
              onChange={(e) => setFormData({ ...formData, text: e.target.value })}
            ></textarea>

            <label className="flex items-center gap-[8px] text-[12px] xl:text-[14px] text-[#3ea138] cursor-pointer PtRoot font-[700] mt-[12px]">
              <input type="checkbox" className="accent-[#3ea138] w-[14px] h-[14px]" onChange={(e) => setFormData({ ...formData, checkbox: e.target.checked })} />
              {t('home.45')}
            </label>

            <p
              onClick={handleSubmit}
              className="rounded-[60px] bg-[#3ea138] cursor-pointer mt-[20px] text-white uppercase PtRoot font-[700] py-[14px] px-[40px] hover:px-[20px] transition-all"
            >
              {t('home.46')}
            </p>
          </form>
        </div>
      </div>
    </>
  );
}

export default Main;

